export default {
	date_range_selection_days_label: 'Tage',
	date_selection_disabled_only_in_mine_or_all_tooltip: 'Nur in den Tabs „Meine" oder „Alle" verfügbar',
	date_selection_next_range_tooltip: 'Nächster Zeitraum',
	date_selection_open_calendar_tooltip: 'Kalender öffnen',
	date_selection_previous_range_tooltip: 'Vorheriger Zeitraum',
	date_selection_today_button_label: 'Heute',
	direction_filter_combined: 'Kombiniert',
	direction_filter_in: 'Eingehend',
	direction_filter_out: 'Ausgehend',
	empty_state_action_adjust_timerange: 'Zeitraum anpassen',
	empty_state_action_clear_favorites: 'Favoriten zurücksetzen',
	empty_state_action_clear_search: 'Suche zurücksetzen',
	empty_state_action_open_filter: 'Filter öffnen',
	empty_state_action_retry: 'Erneut versuchen',
	empty_state_action_show_all: 'Alle anzeigen',
	empty_state_desc_error: 'Die Liste konnte nicht geladen werden.',
	empty_state_desc_filter_unselected: 'Wähle Module oder Benutzer, dann erscheinen hier ihre Einträge.',
	empty_state_desc_filtered_favorite: 'Passe die Favoriten an oder setze sie zurück.',
	empty_state_desc_filtered_search: 'Versuche einen anderen Suchbegriff.',
	empty_state_desc_scope: 'Mit der aktuellen Auswahl gibt es keine Treffer.',
	empty_state_desc_search_term_too_short: 'Die Mail-Suche benötigt mindestens {minimumLength} Zeichen.',
	empty_state_noun_agenda: 'Termine',
	empty_state_noun_document: 'Dokumente',
	empty_state_noun_inbox: 'Einträge',
	empty_state_noun_mail: 'Mails',
	empty_state_noun_message: 'Nachrichten',
	empty_state_noun_note: 'Merkzettel',
	empty_state_noun_notebook: 'Mappen',
	empty_state_noun_phone_call: 'Anrufe',
	empty_state_noun_task: 'Aufgaben',
	empty_state_noun_trash: 'Elemente',
	empty_state_title_agenda: 'Keine Termine',
	empty_state_title_document: 'Keine Dokumente',
	empty_state_title_error: 'Etwas ist schiefgelaufen',
	empty_state_title_filter_unselected: 'Noch keine Module gewählt',
	empty_state_title_filtered_favorite: 'Keine Treffer mit aktiven Favoriten',
	empty_state_title_filtered_search: 'Keine Treffer für „{term}"',
	empty_state_title_inbox: 'Keine Einträge',
	empty_state_title_mail: 'Keine Mails',
	empty_state_title_message: 'Keine Nachrichten',
	empty_state_title_note: 'Keine Merkzettel',
	empty_state_title_notebook: 'Keine Mappen',
	empty_state_title_phone_call: 'Keine Anrufe',
	empty_state_title_scope_mine: 'Keine eigenen {noun}',
	empty_state_title_scope_open: 'Keine offenen {noun}',
	empty_state_title_scope_timeframe: 'Keine {noun} in diesem Zeitraum',
	empty_state_title_search_term_too_short: 'Suchbegriff zu kurz',
	empty_state_title_task: 'Keine Aufgaben',
	empty_state_title_trash: 'Papierkorb ist leer',
	generic_list_all_done: 'Alles erledigt',
	generic_list_bulk_actions_menu_label: 'Aktionen',
	generic_list_bulk_selection_count: '{count} ausgewählt',
	generic_list_column_channel: 'Kanal',
	generic_list_column_contact: 'Kontakt',
	generic_list_column_info_modul: 'Modul Information',
	generic_list_column_information: 'Information',
	generic_list_column_order_description:
		'Welche Spalten sollen in der kompakten Ansicht angezeigt werden und in welcher Reihenfolge?',
	generic_list_column_timestamp: 'Zeit',
	generic_list_context_menu_add_to_existing_task: 'Zu bestehender Aufgabe hinzufügen',
	generic_list_context_menu_create_and_link_ido: 'Akte anlegen',
	generic_list_context_menu_create_ido_in_last_used_instance: '{instanceName} anlegen',
	generic_list_context_menu_create_task: 'Aufgabe anlegen',
	generic_list_context_menu_download_documents_as_zip: 'Als ZIP herunterladen',
	generic_list_context_menu_ido_frequently_used_instances: 'Häufig genutzt',
	generic_list_context_menu_ido_infrequently_used_instances: 'Wenig genutzt',
	generic_list_context_menu_ido_last_used_instance: 'Zuletzt verwendet: {instanceName}',
	generic_list_context_menu_ido_loading_instances: 'Instanzen werden geladen...',
	generic_list_context_menu_ido_no_instances: 'Keine Instanzen verfügbar',
	generic_list_context_menu_link_existing_ido: 'Verknüpfung hinzufügen',
	generic_list_context_menu_remove_from_folder: 'Aus der Mappe entfernen',
	generic_list_context_menu_remove_from_folder_success: 'Das Element wurde aus der Mappe entfernt',
	generic_list_context_menu_search_contact_history: 'Kontakthistorie',
	generic_list_context_menu_send_document_via_mail: 'Per Mail versenden',
	generic_list_context_menu_sheet_selected_count: '{count} ausgewählt',
	generic_list_default_clear_action: 'Standard zurücksetzen',
	generic_list_default_clear_confirm_accept: 'Zurücksetzen',
	generic_list_default_clear_confirm_header: 'Standard zurücksetzen?',
	generic_list_default_clear_confirm_message:
		'Die gespeicherte Standardansicht für dieses Modul wird gelöscht. Die aktuelle Ansicht bleibt erhalten, beim nächsten Modulwechsel wird aber kein Standard mehr angewendet.',
	generic_list_default_clear_success: 'Die Standardansicht wurde zurückgesetzt.',
	generic_list_default_load_action: 'Standard-Ansicht laden',
	generic_list_default_save_as_action: 'Diese Ansicht als Standard speichern',
	generic_list_default_save_confirm_accept: 'Speichern',
	generic_list_default_save_confirm_header: 'Als Standard speichern?',
	generic_list_default_save_confirm_message_new:
		'Die aktuelle Ansicht wird als Standard für dieses Modul gespeichert und beim nächsten Modulwechsel automatisch geladen.',
	generic_list_default_save_confirm_message_overwrite:
		'Der bestehende Standard für dieses Modul wird überschrieben. Die aktuelle Ansicht wird als neuer Standard gespeichert.',
	generic_list_default_save_success: 'Die Standardansicht für dieses Modul wurde gespeichert.',
	generic_list_export_confirm_accept: 'Exportieren',
	generic_list_export_confirm_header: 'Alle Einträge exportieren',
	generic_list_export_confirm_message: 'Es werden {count} Einträge exportiert. Möchten Sie fortfahren?',
	generic_list_export_csv: 'Exportieren als CSV',
	generic_list_export_error: 'Der Export ist fehlgeschlagen.',
	generic_list_export_html: 'Exportieren als HTML',
	generic_list_export_pdf_landscape: 'Exportieren als PDF Querformat',
	generic_list_export_pdf_portrait: 'Exportieren als PDF Hochformat',
	generic_list_export_phase_building: 'Datei wird erstellt…',
	generic_list_export_phase_loading: '{count} Einträge werden geladen…',
	generic_list_export_success: 'Der Export wurde heruntergeladen.',
	generic_list_export_timeout: 'Der Export hat zu lange gedauert. Bitte versuchen Sie es erneut.',
	generic_list_export_tooltip: 'Exportieren',
	generic_list_export_tsv: 'Exportieren als TSV',
	generic_list_export_xlsx: 'Exportieren als XLSX',
	generic_list_filter_toggle_tooltip: 'Filter ein-/ausblenden',
	generic_list_grouped_status_archived: 'Archiviert',
	generic_list_grouped_status_button_aria_label: 'Beteiligtenstatus anzeigen',
	generic_list_grouped_status_button_tooltip: 'Beteiligtenstatus anzeigen',
	generic_list_grouped_status_delegated: 'Geteilt',
	generic_list_grouped_status_direct: 'Direkt',
	generic_list_jump_to_top: 'Nach oben',
	generic_list_large_list_layout_tooltip: 'Ansicht umschalten',
	generic_list_loading: 'Wird geladen…',
	generic_list_loading_more_progress: 'Lade {from}–{to} von {total}',
	generic_list_multi_actions: 'Aktionen',
	generic_list_multi_select_checkbox_aria_label: 'Eintrag auswählen',
	generic_list_multi_select_tooltip: 'Mehrfachauswahl',
	generic_list_searching_for: 'Suche nach „{term}"…',
	generic_list_select_all_header_tooltip: 'Alle markieren / Auswahl aufheben',
	generic_list_select_all_in_group_tooltip: 'Alle in dieser Gruppe markieren',
	generic_list_shared_query_clear_selection: 'Listenauswahl aufheben',
	generic_list_shared_query_group_actions: 'Aktionen',
	generic_list_shared_query_group_lists: 'Gespeicherte Listen',
	generic_list_shared_query_menu_tooltip: 'Listenmenü öffnen',
	generic_list_shared_query_save_as_action: 'Liste unter neuem Namen speichern',
	generic_list_shared_query_save_as_context:
		'Suche, Filter, Zeitraum und Sortierung dieser Liste werden mitgespeichert.',
	generic_list_shared_query_save_as_dialog_title: 'Liste speichern unter',
	generic_list_shared_query_save_as_field_label: 'Listenname',
	generic_list_shared_query_save_as_name_placeholder: 'z. B. Offene Aufgaben – Vertrieb',
	generic_list_shared_query_save_button: 'Speichern',
	generic_list_shared_query_save_error: 'Die Liste konnte nicht gespeichert werden.',
	generic_list_shared_query_save_success: 'Die Liste "{name}" wurde gespeichert.',
	generic_list_shared_query_save_unsupported_time_range:
		'Dieser Zeitraum kann nicht verlustfrei als Legacy-Liste gespeichert werden.',
	generic_list_sort_by: 'Sortieren nach',
	generic_list_sort_order: 'Sortierreihenfolge',
	generic_list_sort_order_a_to_z: 'A bis Z',
	generic_list_sort_order_ascending: 'Aufsteigend',
	generic_list_sort_order_descending: 'Absteigend',
	generic_list_sort_order_newest_first: 'Neueste zuerst',
	generic_list_sort_order_oldest_first: 'Älteste zuerst',
	generic_list_sort_order_z_to_a: 'Z bis A',
	generic_list_sort_property_channel: 'Kanal',
	generic_list_sort_property_date_time: 'Zeit',
	generic_list_sort_property_information: 'Information',
	generic_list_sort_tooltip: 'Sortierung',
	generic_list_status_change_is_being_performed: 'Statuswechsel wird durchgeführt...',
	generic_list_viewed_user_mine: 'Meine Startseite',
	generic_list_viewed_user_select_sheet_title: 'Startseite von Benutzer',
	grouping_module_label_activity: 'Aktennotiz',
	grouping_module_label_appointment: 'Termine',
	grouping_module_label_document: 'Dokumente',
	grouping_module_label_mail: 'Mails',
	grouping_module_label_message: 'Nachrichten',
	grouping_module_label_note: 'Merkzettel',
	grouping_module_label_phoneCall: 'Anrufe',
	grouping_module_label_scheduled_activity: 'Akten',
	grouping_module_label_task: 'Aufgaben',
	grouping_timeframe_label_lastMonth: 'Letzter Monat',
	grouping_timeframe_label_lastWeek: 'Letzte Woche',
	grouping_timeframe_label_next_month: 'nächsten Monat',
	grouping_timeframe_label_next_week: 'nächste Woche',
	grouping_timeframe_label_next_year: 'nächstes Jahr',
	grouping_timeframe_label_olderThanAMonth: 'Vor mehr als einem Monat',
	grouping_timeframe_label_this_year: 'Dieses Jahr',
	grouping_timeframe_label_thisMonth: 'Dieser Monat',
	grouping_timeframe_label_thisWeek: 'Diese Woche',
	grouping_timeframe_label_today: 'Heute',
	grouping_timeframe_label_tomorrow: 'Morgen',
	grouping_timeframe_label_yesterday: 'Gestern',
	inbox_footer_options_reset: 'Zurücksetzen',
	inbox_footer_options_sheet_title: 'Ansicht der Startseite',
	inbox_footer_options_shortcuts_section: 'Shortcuts',
	inbox_footer_options_start_page_section: 'Startseite',
	mini_calendar_last_four_weeks_label: 'Die letzten vier Wochen',
	mini_calendar_last_month_label: 'Letzter Monat',
	mini_calendar_last_week_label: 'Letzte Woche',
	mini_calendar_mode_day_label: 'Tag',
	mini_calendar_mode_range_label: 'Zeitraum',
	mini_calendar_this_month_label: 'Dieser Monat',
	mini_calendar_this_week_label: 'Diese Woche',
	mini_calendar_today_label: 'Heute',
	mini_calendar_yesterday_label: 'Gestern',
	module_chip_label_activity: 'Aktennotiz',
	module_chip_label_appointment: 'Termin',
	module_chip_label_document: 'Dokument',
	module_chip_label_mail: 'Mail',
	module_chip_label_message: 'Nachricht',
	module_chip_label_note: 'Merkzettel',
	module_chip_label_phoneCall: 'Anruf',
	module_chip_label_scheduled_activity: 'Aktennotiz',
	module_chip_label_task: 'Aufgabe',
	multi_action_confirm_label: 'Ja',
	multi_action_delete_dialog_title: 'Löschen bestätigen',
	multi_action_delete_question: 'Möchten Sie wirklich alle ausgewählten Elemente löschen?',
	multi_action_discard_label: 'Nein',
	multi_action_label_appointment: 'Termine',
	multi_action_label_document: 'Dokumente',
	multi_action_label_mail: 'Mails',
	multi_action_label_message: 'Nachrichten',
	multi_action_label_note: 'Merkzettel',
	multi_action_label_phoneCall: 'Anrufe',
	multi_action_label_scheduled_activity: 'Aktennotizen',
	multi_action_label_task: 'Aufgaben',
	multi_action_publish_change_dialog_title: 'Veröffentlichungsänderung bestätigen',
	multi_action_publish_change_question_publish: 'Möchten Sie wirklich alle ausgewählten Elemente veröffentlichen?',
	multi_action_publish_change_question_un_publish: 'Möchten Sie wirklich alle ausgewählten Elemente verbergen?',
	multi_action_restore_dialog_title: 'Wiederherstellen bestätigen',
	multi_action_restore_question: 'Möchten Sie wirklich alle ausgewählten Elemente wiederherstellen?',
	multi_action_selection_count_module_activity_label_multiple: 'Aktennotizen',
	multi_action_selection_count_module_activity_label_single: 'Aktennotiz',
	multi_action_selection_count_module_appointment_label_multiple: 'Termine',
	multi_action_selection_count_module_appointment_label_single: 'Termin',
	multi_action_selection_count_module_document_label_multiple: 'Dokumente',
	multi_action_selection_count_module_document_label_single: 'Dokument',
	multi_action_selection_count_module_mail_label_multiple: 'Mails',
	multi_action_selection_count_module_mail_label_single: 'Mail',
	multi_action_selection_count_module_message_label_multiple: 'Nachrichten',
	multi_action_selection_count_module_message_label_single: 'Nachricht',
	multi_action_selection_count_module_note_label_multiple: 'Merkzettel',
	multi_action_selection_count_module_note_label_single: 'Merkzettel',
	multi_action_selection_count_module_phoneCall_label_multiple: 'Anrufe',
	multi_action_selection_count_module_phoneCall_label_single: 'Anruf',
	multi_action_selection_count_module_task_label_multiple: 'Aufgaben',
	multi_action_selection_count_module_task_label_single: 'Aufgabe',
	multi_action_selection_header: 'Auswahl',
	multi_action_spam_dialog_title: 'Spammen bestätigen',
	multi_action_spam_question: 'Möchten Sie wirklich alle ausgewählten Elemente spammen?',
	multi_action_state_change_dialog_title: 'Statusänderung bestätigen',
	multi_action_state_change_question_prefix: 'Möchten Sie wirklich alle ausgewählten Elemente als',
	multi_action_state_change_question_suffix: 'markieren?',
	multi_action_task_scheduling_dialog_title: 'Aufgabenplanung bestätigen',
	multi_action_task_scheduling_dialog_title_next_week: 'Aufgaben auf nächste Woche verschieben',
	multi_action_task_scheduling_dialog_title_specific_date: 'Aufgaben auf bestimmtes Datum planen',
	multi_action_task_scheduling_dialog_title_tomorrow: 'Aufgaben auf morgen verschieben',
	multi_action_task_scheduling_question: 'Möchten Sie wirklich alle ausgewählten Aufgaben planen?',
	multi_action_task_scheduling_question_next_week:
		'Möchten Sie wirklich alle ausgewählten Aufgaben auf nächste Woche verschieben?',
	multi_action_task_scheduling_question_specific_date:
		'Möchten Sie wirklich alle ausgewählten Aufgaben auf das ausgewählte Datum planen?',
	multi_action_task_scheduling_question_tomorrow:
		'Möchten Sie wirklich alle ausgewählten Aufgaben auf morgen verschieben?',
	multi_document_zip_confirm_cancel_label: 'Abbrechen',
	multi_document_zip_confirm_message: 'Es werden {count} Dokumente geladen und als ZIP-Datei verpackt. Fortfahren?',
	multi_document_zip_confirm_ok_label: 'Herunterladen',
	multi_document_zip_confirm_title: 'Als ZIP herunterladen',
	multi_document_zip_failed: 'Der ZIP-Download ist fehlgeschlagen',
	multi_document_zip_packaging: 'ZIP-Datei wird erstellt…',
	multi_document_zip_progress: 'Dokument {current} von {total} wird geladen…',
	multi_document_zip_success: 'ZIP-Datei mit {count} Dokumenten heruntergeladen',
	multi_task_next_week: 'Auf nächste Woche verschieben',
	multi_task_next_week_notification: 'Aufgaben auf nächste Woche verschoben',
	multi_task_schedule_to_date: 'Auf Datum planen...',
	multi_task_scheduled_notification: 'Aufgaben auf {date} geplant',
	multi_task_tomorrow: 'Auf morgen verschieben',
	multi_task_tomorrow_notification: 'Aufgaben auf morgen verschoben',
	select_date_hint: 'Nur heute und zukünftige Daten können ausgewählt werden',
	select_date_label: 'Datum auswählen',
	task_schedule_to_date: 'Auf Datum planen...',
	task_scheduled_notification: 'Aufgabe auf {date} geplant',
};
